import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3098';

class AuthService {
  constructor() {
    this.token = localStorage.getItem('authToken');
    
    try {
      const userData = localStorage.getItem('user');
      this.user = (userData && userData !== 'undefined' && userData !== 'null') ? JSON.parse(userData) : null;
    } catch (error) {
      console.warn('Error parsing user data from localStorage:', error);
      this.user = null;
      localStorage.removeItem('user');
    }
  }

  async login(email, password) {
    try {
      const response = await axios.post(`${API_BASE_URL}/cms/auth/login`, {
        email,
        password
      });

      if (response.data.success) {
        // Backend returns user data in response.data.data.user
        this.user = response.data.data?.user || response.data.user;
        this.token = response.data.token || 'authenticated';
        
        // Only store in localStorage if we have valid user data
        if (this.user && typeof this.user === 'object') {
          localStorage.setItem('authToken', this.token);
          localStorage.setItem('user', JSON.stringify(this.user));
          return { success: true, user: this.user };
        } else {
          console.error('Invalid user data received from backend:', this.user);
          return { success: false, error: 'Invalid user data received from server' };
        }
      } else {
        return { success: false, error: response.data.error };
      }
    } catch (error) {
      console.error('Login error:', error);
      return { 
        success: false, 
        error: error.response?.data?.error || 'Login failed. Please try again.' 
      };
    }
  }

  async logout() {
    try {
      await axios.post(`${API_BASE_URL}/cms/auth/logout`);
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      this.token = null;
      this.user = null;
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
    }
  }

  isAuthenticated() {
    return !!this.token && !!this.user && typeof this.user === 'object';
  }

  getUser() {
    return this.user;
  }

  getToken() {
    return this.token;
  }

  clearStorage() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    this.token = null;
    this.user = null;
  }
}

export default new AuthService();